// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { maintenanceCostAllocationTRApi } from '../../lib/api';
import { type MaintenanceCostAllocationTR } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/maintenance-cost-allocation-tr/';

export default (props: PageProps) => {
  const [data: MaintenanceCostAllocationTR, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await maintenanceCostAllocationTRApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: MaintenanceCostAllocationTR) => {
    let id = payload.id;
    if (id) {
      await maintenanceCostAllocationTRApi.update(payload);
    } else {
      let data = await maintenanceCostAllocationTRApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: MaintenanceCostAllocationTR) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Распределение затрат на ТР'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
